import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FirebaseService } from '../../common/firebase/firebase.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  genInvoice(walletTransactionId: string) {

    const gen_invoice_url = `${environment.shout_api.url}/wallet/wallet-transactions/${walletTransactionId}/invoice`;
    return this.http.post(gen_invoice_url, null, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}
